<template>
  <header>
    <button class="filter" :data-active="statusFilters" @click="$emit('clickFilters')" title="Filtres"><svgicon name="sport/games/filter" /></button>
    <h1>Games - Multisports</h1>
    <svgicon class="state" name="sport/games/connected" :data-state="state"/>
    <i class="el-icon-loading" v-show="loading"></i>
  </header>
</template>

<script>
export default {
  name: 'SportGamesHeader',
  props: {
    statusFilters: Boolean
  },
  computed: {
    loading () { return this.$store.getters['Sport/Game/loading'] },
    state () { return this.$store.getters['Server/status'] }
  }
}
</script>

<style scoped>
  header{
    position:sticky;
    top:0;
    background-color:var(--color-primary-bg);
    color:var(--color-primary);
    min-height:40px;
    display:flex;
    align-items:center;
    z-index:1;
    gap:8px;
  }
  header > .filter{
    margin:0 10px;
    padding:0;
    background-color:transparent;
    width:30px;
    height:30px;
    border:1px var(--color-primary) solid;
    border-radius:4px;
    cursor:pointer
  }
  header > .filter > svg{
    width:100%;
    height:100%;
    fill:var(--color-primary-bg);
    stroke:var(--color-primary);
    stroke-width:5px;
    stroke-linecap:round;
    stroke-linejoin:round;
    transition:all 2s ease-in-out;
  }
  header > .filter[data-active="true"]{
    background-color:var(--color-primary)
  }
  header > .filter[data-active="true"] > svg{
    fill:var(--color-primary);
    stroke:var(--color-primary-bg);
  }
  header > h1{
    font-size:20px;
    margin:0;
    font-weight:400
  }
  header > .state{
    stroke:white;
    fill:none;
    stroke-width:10;
    stroke-linecap:round;
    stroke-linejoin:round;
    height:20px;
    width:20px;
    transition:all 0.5s ease-in-out;
  }
  /* data-state = WebSocket.readyState : 0 CONNECTING, 1 OPEN, 2 CLOSING, 3 CLOSED */
  header > .state[data-state="1"]{
    stroke:green;
  }
  header > .state[data-state="0"]{
    stroke:yellow;
  }
  header > .state[data-state="2"]{
    stroke:orange;
  }
  header > .state[data-state="3"]{
    stroke:red;
  }
</style>
<style>
  header > .filter > svg > .circle-1,
  header > .filter > svg > .circle-2{
    transition:all 0.5s ease-in-out
  }
  header > .filter:hover > svg > .circle-1{
    cx:70px
  }
  header > .filter:hover > svg > .circle-2{
    cx:30px
  }
</style>
